import {
  Message,
  MessageSender,
  MessageType,
  TemplateId,
} from "@/app/store/types";
import React, { useState } from "react";
import styles from "./Template.module.scss";
import Locale from "@/app/locales";
import History from "./History";
import { parseMessageContent, tryParse } from "@/app/utils/object";
import { isWithdrawnMsg } from "@/app/store/formatMessage";
import { useMessageStore } from "@/app/store";
import { Toast } from "@douyinfe/semi-ui";

/** 重新编辑有效时长：3 分钟（与撤回规则一致） */
const RE_EDIT_WINDOW_MS = 3 * 60 * 1000;

const isWithinReEditWindow = (timestamp: number = 0) =>
  Date.now() - timestamp <= RE_EDIT_WINDOW_MS;

interface IProps {
  msg: Message;
}
export default function Template(props: IProps) {
  const { msg } = props;
  const setReEditContent = useMessageStore((state) => state.setReEditContent);
  const setQuotedMsg = useMessageStore((state) => state.setQuotedMsg);
  const [reEditHidden, setReEditHidden] = useState(false);

  const handleReEdit = () => {
    if (!isWithinReEditWindow(msg.recallTime as number)) {
      Toast.warning(Locale.systemMsg.reEditExpired);
      setReEditHidden(true);
      return;
    }
    const content = tryParse(msg.content);
    const text = typeof content?.text === "string" ? content.text : "";
    // 恢复引用信息（若原消息有 quoteMessage）
    if (msg.quoteMessage) {
      setQuotedMsg(msg.quoteMessage);
    } else {
      setQuotedMsg(undefined);
    }
    setReEditContent(text);
  };

  const getText = () => {
    if (msg.type === MessageType.Template) {
      if (msg.templateId === TemplateId.History) {
        return <span className={styles.history}>{Locale.chat.historyMsg}</span>;
      } else if (msg.templateId === TemplateId.More_History) {
        return <History />;
      }
    } else if (isWithdrawnMsg(msg)) {
      if (msg.senderType === MessageSender.AGENT) {
        return Locale.systemMsg.msgWithDrawnByOthers;
      }
      let canReEdit = isWithinReEditWindow(msg.timestamp) && !reEditHidden;
      const isText = tryParse(msg.content)?.text;
      if (!isText) {
        canReEdit = false;
      }
      return (
        <>
          {Locale.systemMsg.msgWithDrawn}
          {canReEdit && (
            <span className={styles.reEdit} onClick={handleReEdit}>
              {Locale.button.reEdit}
            </span>
          )}
        </>
      );
    } else if (msg.type === MessageType.MessageSatisfyResult) {
      return (
        <span className={styles.history}>
          {Locale.systemMsg.satisfyComment}
        </span>
      );
    }
    const content = parseMessageContent(msg.content);
    if (!content) {
      return;
    }
    return content.text;
  };

  return <div className={`${styles.template} `}>{getText()}</div>;
}
